export var RiskLevelEnum;
(function (RiskLevelEnum) {
    RiskLevelEnum["LOW"] = "LOW";
    RiskLevelEnum["MEDIUM"] = "MEDIUM";
    RiskLevelEnum["HIGH"] = "HIGH";
})(RiskLevelEnum || (RiskLevelEnum = {}));
//# sourceMappingURL=risk-level.enum.js.map